if (!customElements.get('wlsn-press-tabs')) {
    class WLSNPressTabs extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                activeClass: 'is-active',
                visibleClass: 'is-visible',
                hiddenClass: 'is-hidden',
                tab: 'js-wlsn-press-tab',
                content: 'js-wlsn-press-content',
                newsArticle: 'js-wlsn-press-news-article',
                loadMore: 'js-wlsn-press-load-more'
            };
            this.itemsPerLoad = 6;
            this.visibleCounts = new Map();
        }

        connectedCallback() {
            this.initTabs();
        }

        initTabs() {
            const tabs = this.querySelectorAll(`.${this.classes.tab}`);
            const contents = this.querySelectorAll(`.${this.classes.content}`);
            const { activeClass, visibleClass } = this.classes;

            tabs.forEach((tab, index) => {
                tab.addEventListener('click', () => {
                   
                    tabs.forEach(t => t.classList.remove(activeClass));
                    tab.classList.add(activeClass);

                    
                    contents.forEach(c => c.classList.remove(activeClass, visibleClass));
                    const contentEl = contents[index];
                    contentEl.classList.add(activeClass, visibleClass);

                    this.setupLoadMore(contentEl);
                });
            });

            if (contents[0]) {
                contents[0].classList.add(activeClass, visibleClass);
                this.setupLoadMore(contents[0]);
            }
        }

        setupLoadMore(contentEl) {
            const items = contentEl.querySelectorAll(`.${this.classes.newsArticle}`);
            const loadMoreBtn = contentEl.querySelector(`.${this.classes.loadMore}`);

            if (!items.length || !loadMoreBtn) return;

            if (!this.visibleCounts.has(contentEl)) {
                this.visibleCounts.set(contentEl, this.itemsPerLoad);
            }

            let visibleCount = this.visibleCounts.get(contentEl);

            items.forEach((item, i) => item.style.display = i < visibleCount ? "" : "none");

            if (visibleCount >= items.length) {
                loadMoreBtn.classList.add(this.classes.hiddenClass);
            } else {
                loadMoreBtn.classList.remove(this.classes.hiddenClass);
            }

            loadMoreBtn.onclick = null;

            loadMoreBtn.addEventListener('click', () => {
                visibleCount += this.itemsPerLoad;
                this.visibleCounts.set(contentEl, visibleCount);

                items.forEach((item, i) => item.style.display = i < visibleCount ? "" : "none");

                if (visibleCount >= items.length) {
                    loadMoreBtn.classList.add(this.classes.hiddenClass);
                }
            });
        }
    }

    customElements.define('wlsn-press-tabs', WLSNPressTabs);
}
